import { APP_USER_ID } from "@/enum/cookie.name.enum.ts";
import { APP_USER_ID_REQUEST_HEADER_NAME } from "@/enum/request.header.name.enum.ts";

const baseURL = process.env.NEXT_PUBLIC_APP_API_BASE_URL;

export interface ApiResponse<T> {
  data: T;
  error?: string;
}

class FetchInstance {
  async post(pathname: string, data: object = {}) {
    const userId = this.getUserId();

    return fetch(
      baseURL + pathname,
      {
        method: "POST",
        body: JSON.stringify({ ...data, userId }),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
      }
    )
  }

  get(pathname: string) {
    const userId = this.getUserId() as string;

    return fetch(
      baseURL + pathname,
      {
        method: "GET",
        credentials: 'include',
        headers: {
          [APP_USER_ID_REQUEST_HEADER_NAME]: userId,
        },
      }
    );
  }

  async put(pathname: string, data: object = {}) {
    const userId = this.getUserId();

    return fetch(
      baseURL + pathname,
      {
        method: "PUT",
        body: JSON.stringify({ ...data, userId }),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
      }
    )
  }

  async delete(pathname: string, data?: object) {
    const userId = this.getUserId();

    return fetch(
      baseURL + pathname,
      {
        body: JSON.stringify({ ...(data ?? {}), userId }),
        headers: {
          "Content-Type": "application/json",
        },
        method: "DELETE",
        credentials: 'include',
      }
    );
  }

  private getUserId(): string | undefined {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${APP_USER_ID}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift();
    }

    return undefined;
  }
}

const fetchInstance = new FetchInstance()

export default fetchInstance
